import React, {useState, useEffect, useRef} from 'react';

const TIME_INTERVAL = 100

const CarEvent = props => {
    const [eventActive, setEventActive] = useState(false);
    const [eventOver, setEventOver] = useState(false);

    const [carDistance, setCarDistance] = useState(0);

    const ANIMATION_FRAMERATE = 1000 / 60;
    const previousCarDistance =  React.useRef();

    const startCar = useRef(false)
    const currentTime = useRef(0)
    
    const eventsToProcess = useRef(props?.data?.timedEvents.map( e => ({ ...e, processed: false})) || [])


    const styleObject = {       
        transform: `translate3d(${
            props.xOffset
        }%, ${
            props.yOffset
        }%, ${
            props.zOffset
        }px)`,
        zIndex: props.zIndex
    }

    
    function startCarMotion() {
         setCarDistance((carDistance) => carDistance + props?.data.carSpeed)
    }
    
    useEffect( () => {
        const carInterval = setInterval(() => {
            if (startCar.current === true) {
                startCarMotion()
            }
        }, 100)

        const mainInterval = setInterval( () => {
            if (eventActive && !eventOver) {
                if(carDistance < props.data.finishPosition) {  // car is still moving
                    eventsToProcess.current &&  eventsToProcess.current.forEach((e,i) => {
                        if (e.processed === true) return;
                        if (e.time > currentTime.current) return
                        eventsToProcess.current[i].processed = true
                        switch (e.event) {
                            case 'take_off':
                                startCar.current = true;
                                break;
                            case 'green_light':
                                console.log('Green Light event fired at ' + e.time)
                                props.updateRoad('greenLightOn')
                                break;
                            default:
                                console.log(`Unhandled event of type: ${e.event} at ${e.time}`)
                                break
                        }

                    })
                } else {
                    setEventActive(false)
                    setEventOver(true)
                    props.setCompletedRoadEvents( (state)=>{
                            const newCompletedEvents = [...state];
                            newCompletedEvents[props.data.eventId] = true;
                            return newCompletedEvents
                        }
                    )
                }
                currentTime.current += TIME_INTERVAL
            }

        }, TIME_INTERVAL )
        
        return () => {
             clearInterval(carInterval)
             clearInterval(mainInterval)
        }
    })
    
    
    
   
    useEffect(() => {
        if (props.didStopCorrectly) {

            if(props.delay){
                const trainTimeout = setTimeout(() => {
            setEventActive(true)
                }, (props.delay * 1000));
                // clear timeout before unmount
                return () => clearTimeout(trainTimeout)
            }else{
                setEventActive(true);
            }
        }
    }, [props.didStopCorrectly])

 

    useEffect(() => {
        props.setAnimateObject(carDistance)
    }, [carDistance])
    return (       
        carDistance < 25000 ? <div className={`CarEvent`} style={{zIndex: props.zIndex}}>           
            <div className={`car-image`} style={styleObject}/>
        </div> : <></>
        )
}

export default CarEvent
